module.exports = __webpack_public_path__ + "static/media/DrinkItem_state0_elImage_650029.4f14dc8d.jpg";